<template>
    <section>
        <sui-segment basic>
            <sui-button basic icon="reply" floated="left" @click="$router.push({ name: recordName + 'List' })">Regresar</sui-button>
            <h2 is="sui-header" floated="right" color="grey">
                <sui-icon name="edit"/>
                <sui-header-content>Detalle de queja</sui-header-content>
            </h2>
            <br><br>
        </sui-segment>
        <sui-grid>
            <sui-grid-row>
                <sui-grid-column :width="13">
                    <sui-segment>
                        <sui-form>
                            <sui-header dividing>Registro de queja</sui-header>
                            <sui-form-fields fields="two">
                                <sui-form-field :error="!record.entityName">
                                    <label>Denominación o razón social</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.id"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.entityName"
                                        :options="entityOptions"
                                        @input="setSectorField"
                                    />
                                    <span v-else>{{ record.entityName }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="two">
                                <sui-form-field :error="!record.sector">
                                    <label>Sector</label>
                                    <input
                                        v-if="record.editing && !record.id"
                                        type="text"
                                        readonly
                                        v-model="record.sector"
                                    />
                                    <span v-else>{{ record.sector }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="three">
                                <sui-form-field :error="!record.dateComplaint">
                                    <label>Fecha de queja</label>
                                    <v-date-picker
                                        v-if="record.editing"
                                        v-model="record.dateComplaint"
                                        :masks="masks"
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                </v-date-picker>
                                <span v-else>{{ dateComplaintStr }}</span>
                                </sui-form-field>
                                <sui-form-field>
                                    <label>Número de quejas</label>
                                    <span>1</span>
                                </sui-form-field>
                                <sui-form-field>
                                    <label>Mes a informar</label>
                                    <strong>{{ monthReported }}</strong>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="three">
                                <sui-form-field :error="!record.folio">
                                    <label>Número de folio</label>
                                    <sui-input
                                        v-if="record.editing && !record.id"
                                        type="text"
                                        v-model="record.folio"
                                    />
                                    <span v-else>{{ record.folio }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.receivingMediumId">
                                    <label>Medio de recepción</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.receivingMediumId"
                                        :options="receivingMediumOptions"
                                    />
                                    <span v-else>{{ receptionMediumStr }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.attentionLevelId">
                                    <label>Nivel de atención o contacto</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.attentionLevelId"
                                        :options="attentionLevelOptions"
                                    />
                                    <span v-else>{{ attentionLevelStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="three">
                                <sui-form-field :error="!record.taxRegimeId">
                                    <label>Tipo de persona</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.taxRegimeId"
                                        :options="taxRegimeOptions"
                                    />
                                    <span v-else>{{ taxRegimeStr }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.taxRegimeId == TaxRegime.PERSONA_FISICA">
                                    <label>Edad</label>
                                    <sui-input
                                        v-if="record.editing"
                                        type="number"
                                        v-model="record.age"
                                    />
                                    <span v-else>{{ record.age }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.taxRegimeId == TaxRegime.PERSONA_FISICA">
                                    <label>Género</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.gender"
                                        :options="genderOptions"
                                    />
                                    <span v-else>{{ genderStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="four">
                                <sui-form-field :error="!record.stateId">
                                    <label>Entidad federativa</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.stateId"
                                        :options="stateOptions"
                                    />
                                    <span v-else>{{ stateStr }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.postalCode">
                                    <label>Código postal</label>
                                    <input
                                        v-if="record.editing"
                                        type="text"
                                        v-model="record.postalCode"
                                        @input="(record.postalCode || '').length > 2 ? loadMunicipalities() : null"
                                    />
                                    <span v-else>{{ record.postalCode }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.municipalityId">
                                    <label>Municipio</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.municipalityId"
                                        :options="locationOptions"
                                        @input="loadColonies"
                                    />
                                    <span v-else>{{ municipalityStr }}</span>
                                </sui-form-field>
                                <!-- <sui-form-field>
                                    <label>Localidad</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.locality"
                                    />
                                    <span v-else>{{ record.locality }}</span>
                                </sui-form-field> -->
                                <sui-form-field :error="!record.colonyId">
                                    <label>Colonia</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.colonyId"
                                        :options="colonyOptions"
                                        @input="setLocalityId"
                                    />
                                    <span v-else>{{ colonyStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="three">
                                <sui-form-field :error="!record.identityTheft">
                                    <label>Posible robo de identidad (PORI)</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.identityTheft"
                                        :options="identityTheftOptions"
                                    />
                                    <span v-else>{{ record.identityTheft }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.statusId">
                                    <label>Estatus</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.statusId"
                                        :options="statusOptions"
                                    />
                                    <span v-else>{{ statusStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="three">
                                <sui-form-field>
                                    <label>Sentido de la resolución</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.resolutionId"
                                        :options="resolutionOptions"
                                    />
                                    <span v-else>{{ resolutionStr }}</span>
                                </sui-form-field>
                                <sui-form-field>
                                    <label>Fecha de resolución</label>
                                    <v-date-picker
                                        v-if="record.editing"
                                        v-model="record.dateResolved"
                                        :masks="masks"
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                </v-date-picker>
                                <span v-else>{{ dateResolvedStr }}</span>
                                </sui-form-field>
                                <sui-form-field>
                                    <label>Fecha de notificación</label>
                                    <v-date-picker
                                        v-if="record.editing"
                                        v-model="record.dateNotificated"
                                        :masks="masks"
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                </v-date-picker>
                                <span v-else>{{ dateNotificatedStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="three">
                                <sui-form-field>
                                    <label>Número de penalización</label>
                                    <sui-input
                                        v-if="record.editing"
                                        placeholder="0"
                                        type="number"
                                        v-model="record.penaltyNumber"
                                    />
                                    <span v-else>{{ record.penaltyNumber }}</span>
                                </sui-form-field>
                                <sui-form-field>
                                    <label>Tipo de penalización impuesta</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.penaltyId"
                                        :options="penaltyOptions"
                                    />
                                    <span v-else>{{ penaltyTypeStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="two">
                                <!-- <sui-form-field :error="!record.operationType">
                                    <label>Tipo de operación</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.operationType"
                                        :options="operationType"
                                        @input="setProductTypeOptions"
                                    />
                                    <span v-else>{{ operationTypeStr }}</span>
                                </sui-form-field> -->
                                <sui-form-field :error="!record.productId">
                                    <label>Producto</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.productId"
                                        :options="productOptions"
                                        @input="loadReasons"
                                    />
                                    <span v-else>{{ productTypeStr }}</span>
                                </sui-form-field>
                                <!-- <sui-form-field :error="!record.subproductType">
                                    <label>Subproducto</label>
                                    <sui-dropdown
                                        v-if="record.editing"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.subproductType"
                                        :options="subproductType"
                                    />
                                    <span v-else>{{ subproductTypeStr }}</span>
                                </sui-form-field> -->
                            </sui-form-fields>
                            <sui-form-field :error="!record.reasonId">
                            <label>Causa</label>
                            <sui-dropdown
                                v-if="record.editing"
                                placeholder="Seleccione"
                                selection
                                v-model="record.reasonId"
                                :options="reasonOptions"
                            />
                            <span v-else>{{ reasonStr }}</span>
                        </sui-form-field>
                        </sui-form>
                    </sui-segment>
                </sui-grid-column>
                <sui-grid-column :width="3" textAlign="center">
                            <div class="ui vertical fluid menu">
                                <div class="ui warning message" v-if="!record.active">
                                    <i class="info circle icon"></i> <strong>Queja inhabilitada</strong>
                                </div>
                                <div class="header header-menu">ACCIONES</div>
                                <div class="link item" @click="saveRecord(record)" v-if="!record.id && record.editing">
                                    Agregar
                                </div>
                                <div class="link item" @click="editRecord()" v-if="!record.editing && record.id">
                                    Modificar
                                </div>
                                <div class="link item" @click="saveRecord(record)" v-if="record.id && record.editing">
                                    Guardar
                                </div>
                                <div class="link item" @click="cancelEditRecord()" v-if="record.editing && record.id">
                                    Cancelar
                                </div>
                                <div class="link item"
                                    v-if="record.id && !record.editing && !record.active"
                                    @click="toggleRecordActivation">
                                    Habilitar
                                </div>
                                <div class="link item"
                                    v-if="record.id && !record.editing && record.active"
                                    @click="toggleRecordActivation">
                                    Inhabilitar
                                </div>
                            </div>
                </sui-grid-column>
            </sui-grid-row>
        </sui-grid>
    </section>
</template>

<script>
import Utils from '@/common/Utils.js'
import TaxRegime from '@/common/TaxRegime.js'
import GenderAlt from '@/common/GenderAlt.js'
import IdentityTheft from '@/common/IdentityTheft.js'
import ComplaintService from '@/services/ComplaintService.js'
import Mixins from '@/mixins/index.js'

export default {
    name: 'RedecoComplaintDetails',
    components: {},
    mixins: [ Mixins ],
    data () {
        return {
            TaxRegime,
            apiEndpoint: '/complaints/redeco/',
            recordName: 'RedecoComplaint',
            errors: [],
            entities: [],
            receivingMedium: [],
            states: [],
            locations: [],
            colonies: [],
            resolutions: [],
            penalties: [],
            attentionLevels: [],
            status: [],
            operationType: [],
            products: [],
            subproducts: [],
            reasons: [],
            record: {
                id: null,
                editing: true,
                active: true,
                dateComplaint: new Date(),
                dateResolved: new Date(),
                dateNotificated: new Date()
            }
        }
    },
    async beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }
    },
    async mounted () {
        const loader = this.$loading.show()
        try {
            await this.loadEntities()
            await this.loadReceivingMedium()
            await this.loadAttentionLevels()
            await this.loadStatus()
            await this.loadStates()
            await this.loadResolutions()
            await this.loadPenalties()
            await this.loadProducts()
            if (this.$route.params.id) {
                await this.loadRecord(this.$route.params.id)
                await this.loadReasons()
                await this.loadMunicipalities()
                await this.loadColonies()
            }
        } catch (error) {
            this.$swal('Error', error.message, 'error')
        }
        loader.hide()
    },
    computed: {
        entityOptions () {
            return Utils.displayOptionsFromArray(this.entities, 'entityName', 'entityName')
        },
        receivingMediumOptions () {
            return Utils.displayOptionsFromArray(this.receivingMedium, 'medioId', 'medioDsc')
        },
        attentionLevelOptions () {
            return Utils.displayOptionsFromArray(this.attentionLevels, 'nivelDeAtencionId', 'nivelDeAtencionDsc')
        },
        stateOptions () {
            return Utils.displayOptionsFromArray(this.states, 'claveEdo', 'estado')
        },
        statusOptions () {
            return Utils.displayOptionsFromArray(this.status, 'status_id', 'status_description')
        },
        resolutionOptions () {
            return Utils.displayOptionsFromArray(this.resolutions, 'resolution_id', 'resolution_description')
        },
        penaltyOptions () {
            return Utils.displayOptionsFromArray(this.penalties, 'penalty_id', 'penalty_description')
        },
        productOptions () {
            return Utils.displayOptionsFromArray(this.products, 'productId', 'product')
        },
        reasonOptions () {
            return Utils.displayOptionsFromArray(this.reasons, 'causaId', 'causa')
        },
        locationOptions () {
            return Utils.displayOptionsFromArray(this.locations, 'municipioId', 'municipio')
        },
        colonyOptions () {
            return Utils.displayOptionsFromArray(this.colonies, 'coloniaId', 'colonia')
        },
        taxRegimeOptions () {
            return Utils.displayOptions(TaxRegime)
        },
        genderOptions () {
            return Utils.displayOptions(GenderAlt)
        },
        identityTheftOptions () {
            return Utils.displayOptions(IdentityTheft)
        },
        monthReported: function () {
            return this.moment().locale('es').format('MMMM - YYYY').toUpperCase()
        },
        resolutionStr: function () {
            return this.record.resolutionId ? Utils.displayOptionFromList(this.resolutionOptions, this.record.resolutionId) : '-'
        },
        penaltyTypeStr: function () {
            return this.record.penaltyId ? Utils.displayOptionFromList(this.penaltyOptions, this.record.penaltyId) : '-'
        },
        dateComplaintStr: function () {
            return this.record.dateComplaint ? this.moment(this.record.dateComplaint).format('DD/MM/YYYY') : ''
        },
        dateResolvedStr: function () {
            return this.record.dateResolved ? this.moment(this.record.dateResolved).format('DD/MM/YYYY') : '-'
        },
        dateNotificatedStr: function () {
            return this.record.dateNotificated ? this.moment(this.record.dateNotificated).format('DD/MM/YYYY') : '-'
        },
        receptionMediumStr: function () {
            return this.record.receivingMediumId ? Utils.displayOptionFromList(this.receivingMediumOptions, this.record.receivingMediumId) : ''
        },
        attentionLevelStr: function () {
            return this.record.attentionLevelId ? Utils.displayOptionFromList(this.attentionLevelOptions, this.record.attentionLevelId) : ''
        },
        taxRegimeStr: function () {
            return this.record.taxRegimeId ? Utils.displayOptionFromList(this.taxRegimeOptions, this.record.taxRegimeId) : '-'
        },
        genderStr: function () {
            return this.record.gender ? Utils.displayOptionName(GenderAlt, this.record.gender) : '-'
        },
        statusStr: function () {
            return this.record.statusId ? Utils.displayOptionFromList(this.stateOptions, this.record.statusId) : ''
        },
        operationTypeStr: function () {
            return this.record.operationId ? Utils.displayOptionFromList(this.operationOptions, this.record.operationId) : ''
        },
        productTypeStr: function () {
            return this.record.productId ? Utils.displayOptionFromList(this.productOptions, this.record.productId) : ''
        },
        subproductTypeStr: function () {
            return this.record.subproductId ? Utils.displayOptionFromList(this.subproductOptions, this.record.subproductId) : ''
        },
        reasonStr: function () {
            return this.record.reasonId ? Utils.displayOptionFromList(this.reasonOptions, this.record.reasonId) : ''
        },
        stateStr: function () {
            return this.record.stateId ? Utils.displayOptionFromList(this.stateOptions, this.record.stateId) : ''
        },
        municipalityStr: function () {
            return this.record.municipalityId ? Utils.displayOptionFromList(this.locationOptions, this.record.municipalityId) : ''
        },
        colonyStr: function () {
            return this.record.colonyId ? Utils.displayOptionFromList(this.colonyOptions, this.record.colonyId) : ''
        }
    },
    methods: {
        sortByName (a, b, key = null) {
            const nameA = key ? a[key].toUpperCase() : a.toUpperCase()
            const nameB = key ? b[key].toUpperCase() : b.toUpperCase()
            if (nameA < nameB) return -1
            if (nameA > nameB) return 1
            return 0
        },
        async loadEntities () {
            try {
                const { rows } = await ComplaintService.getRedecoEntitiesCatalog()
                this.entities = rows
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadReceivingMedium () {
            try {
                const { medio } = await ComplaintService.getRedecoReceptionMedium()
                this.receivingMedium = medio
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadAttentionLevels () {
            try {
                const { nivelesDeAtencion } = await ComplaintService.getRedecoAttentionLevels()
                this.attentionLevels = nivelesDeAtencion
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadStates () {
            try {
                const { estados } = await ComplaintService.getCondusefStatesCatalog()
                this.states = estados
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadStatus () {
            try {
                this.status = await ComplaintService.getRedecoStatus()
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadResolutions () {
            try {
                this.resolutions = await ComplaintService.getRedecoResolutions()
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadPenalties () {
            try {
                this.penalties = await ComplaintService.getRedecoPenalties()
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadProducts () {
            try {
                const { products } = await ComplaintService.getRedecoProducts()
                this.products = products
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadReasons () {
            try {
                const { causas } = await ComplaintService.getRedecoReasons(this.record.productId || '')
                this.reasons = causas
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadMunicipalities () {
            try {
                const { municipios } = await ComplaintService.getCondusefMunicipalitiesCatalog(this.record.stateId || '', this.record.postalCode || '')
                this.locations = municipios
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        async loadColonies () {
            try {
                const { colonias } = await ComplaintService.getCondusefColoniesCatalog(this.record.postalCode || '')
                this.colonies = colonias
                return Promise.resolve(true)
            } catch (error) {
                throw new Error('Ocurrio un error al cargar los catalogos')
            }
        },
        setLocalityId () {
            this.record.localityId = this.record.colonyId ? this.colonies.find(colony => colony.coloniaId === this.record.colonyId).tipoLocalidadId : null
        },
        setSectorField () {
            this.record.sector = this.record.entityName ? this.entities.find(entity => entity.entityName === this.record.entityName).sector : ''
        },
        toggleRecordActivation () {
            this.record.active = !this.record.active
            this.saveRecord(this.record)
        }
    }
}
</script>
<style scoped>
    .header-menu {
        padding-top:5px;
        padding-bottom:5px;
        background-color: #1C1D1D;
        color: white;
        font-weight: bolder;
    }
    .item {
        margin-bottom: 5px;
    }
    .left-spaced {
        margin-left: 20px;
    }
    .accepted {
      color: green;
    }
    .rejected {
      color: red;
    }
</style>
